export function Footer2() {
    return (
        <div className="bg-white fixed bottom-0 left-0 w-full border-t overflow-hidden">
            <div className="flex flex-col items-center justify-center p-[1em] h-full">
                <img
                    className="h-[6vh] w-auto landscape:h-[10vh] object-contain animate-ticker-portrait landscape:animate-ticker-landscape"
                    src="/order-on-snackpass.svg"
                    alt="Snackpass Logo"
                />
            </div>
        </div>
    );
}
